import { createSelector } from 'reselect';
import { AllCampaignsObject, ENTITY } from 'modules/campaigns/config';
import { reportEntityIdsSelector, reportEntityTypeSelector } from 'modules/campaigns/selectors';
import { campaignsGroupStateSelector, campaignsGroupMapSelector } from './baseCampaignsGroupSelectors';

export const selectedCampaignGroupIdSelector = createSelector(
    reportEntityIdsSelector,
    reportEntityTypeSelector,
    (reportEntityIds, reportEntityType) => {
        const firstReportEntityId = Array.isArray(reportEntityIds) ? reportEntityIds?.[0] : reportEntityIds;

        return firstReportEntityId && reportEntityType === ENTITY.CAMPAIGNS_GROUP
            ? firstReportEntityId
            : AllCampaignsObject.id;
    }
);

export const editedCampaignsGroupSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupMapSelector,
    (campaignsGroupState, campaignsGroupMap) =>
        (campaignsGroupState.campaignsGroupBeingEdited === null
            ? null
            : campaignsGroupMap[campaignsGroupState.campaignsGroupBeingEdited]) || null
);

export const campaignsGroupModuleStatusSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupState => campaignsGroupState.moduleStatus
);

export const campaignsGroupPickerForceReloadFlagSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupState => campaignsGroupState.forceCampaignPickerReloadFlag
);
